/* istanbul ignore file: this file does not contain any logic, only factory calls */

const IMPREZA_BUTTON_PROPS = {
  className: "w-btn"
};
export { IMPREZA_BUTTON_PROPS };
export * from "./request";
export * from "./i18n";
export * from "./getDecimalSeparator";
export * from "./realCommerceRequest";
export * from "./localStorageTest";
export * from "./persistJwtToken";
export * from "./getJwtPayload";